export const forceDownload = async (url: string) => {
  const iframe = document.createElement('iframe');

  iframe.src = url;
  iframe.style.display = 'none';
  iframe.style.height = '0';

  document.body.appendChild(iframe);

  setTimeout(() => {
    iframe.remove();
  }, 5 * 1000);
};
